<template>
  <div>
    <el-row>
      <el-col>
        <rest-form-item :label="$t('ApplicationForm_Field_Title')" prop="name">
          <el-input v-model="model.name" />
        </rest-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <rest-form-item
          :description="
            $t('ApplicationForm_Field_Huawei_App_ID_Description', {
              url: 'https://docs.xtremepush.com/docs/huawei-application'
            })
          "
          :label="$t('ApplicationForm_Field_Huawei_App_ID')"
          prop="huawei_app_id"
        >
          <el-input v-model="model.huawei_app_id" />
        </rest-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  name: 'AppAndroidHuaweiForm',
  components: { RestFormItem },
  props: {
    model: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/account/components/AppAndroidHuaweiForm.vue